/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import SubHeader from '../../components/SubHeader';
import Details from './components/Details';
import NFFilters from './components/NFFilters';
import TrackingNFList from './components/TrackingNFList';
import SheetDownload from './components/SheetDownload';
import SkeletonTrackingCard from './components/SkeletonTrackingCard';

import {
  getNFList,
  exportExcel,
  changeFilters,
  filtersClear,
  viewNFDetails,
  exportDetailedExcel,
  changeSearchFieldIsInUse,
} from '../../redux/tracking';
import { getNfListLocation } from '../../redux/dashboard-real-time';

import { getCustomerUsersList } from '../../redux/tracking-manager';

import {
  getNFListUI,
  getTrackingExportExcelUI,
  getAddNFEmailTrackingUI,
  getRemoveNFEmailTrackingUI,
  getTrackingExportDetailedExcelUI,
  getCurrentNFDetails,
} from '../../redux/selectors';

import './styles.css';
import SearchSecondary from '../../components/SearchSecondary';

class Tracking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nfDetailsIsVisible: false,
      openOccurenceTab: false,
      showTrackingManager: false,
      showTable: true,
      showNewForm: false,
    };
  }

  componentDidMount() {
    const {
      match: {
        params: { id },
      },
    } = this.props;

    if (id) {
      this._onSearch(id);
      return;
    }

    this.props.dispatch(changeFilters({ currentPage: 1 }));
    this.props.dispatch(getNFList());
  }

  componentDidUpdate(prevProps) {
    // If component has a new active tab or nfList is updated,
    // fetch location using those props
    // const {
    //   match: {
    //     params: { id },
    //   },
    // } = this.props;

    if (
      this.props.listPerformance !== prevProps.listPerformance ||
      this.props.nfList !== prevProps.nfList
    ) {

      this.props.dispatch(
        getNfListLocation(
          this.props.listPerformance.length ? this.props.listPerformance : [1,2,3], 
          this.props.nfList
        ),
      );
    }

    // if (this.state.location !== prevProps.location) {
    //   if (this.props.location.state && this.props.location.state.openDrawerInReceiptExclusion) {
    //     this._onNFAutoClick(id);
    //   }
    // }
  }

  _onSearch = query => {
    const { dispatch } = this.props;
    dispatch(changeFilters({ query }));
    dispatch(getNFList());
    dispatch(filtersClear());
    dispatch(changeSearchFieldIsInUse(true));
  };

  _onClose = () => {
    const { dispatch } = this.props;
    dispatch(filtersClear());
    dispatch(changeSearchFieldIsInUse(false));
    dispatch(getNFList());
  };

  _exportDetailedXLS = () => {
    this.props.dispatch(exportDetailedExcel());
  };

  _exportXLS = () => {
    this.props.dispatch(exportExcel());
  };

  _onNFClick = row => {
    this.props.dispatch(viewNFDetails(row.id));

    this.setState({
      nfDetailsIsVisible: !this.state.nfDetailsIsVisible,
    });
  };

  // _onNFAutoClick = (id) => {
  //   if (this.state.isAutoLoading) return;

  //   this.setState({
  //     isAutoLoading: true
  //   });

  //   const { nfList } = this.props;

  //   const nfSelected = nfList.find(nf => nf.nf === id);

  //   this.props.dispatch(viewNFDetails(nfSelected.id));

  //   this.setState({
  //     nfDetailsIsVisible: true,
  //     openReceiptTab: true,
  //   });

  //   this.setState({
  //     isAutoLoading: false
  //   });
  // }

  _onTrackingManager = () => {
    const { dispatch, nfData } = this.props;

    if (nfData) {
      dispatch(
        getCustomerUsersList({ taxNumber: nfData.cnpjDest, page: 1, take: 5 }),
      );
    }

    this.setState({ showTrackingManager: !this.state.showTrackingManager });
  };

  _setShowTable = isShowTable => {
    this.setState({ showTable: isShowTable });
  };

  _setShowNewForm = isShowNewForm => {
    this.setState({ showNewForm: isShowNewForm });
  };

  _onNFConfirmationClick = row => {
    this._onNFClick(row);
    this._onTrackingManager();
    this._setShowTable(false);
    this._setShowNewForm(true);
  };

  _toggleSidePanel = () => {
    this.setState({
      nfDetailsIsVisible: !this.state.nfDetailsIsVisible,
      openOccurenceTab: false,
      openReceiptTab: false,
    });
  };

  _openOccurence = () => {
    this.setState({ openOccurenceTab: true });
  };

  _openReceipt = () => {
    this.setState({ openReceiptTab: true });
  };

  render() {
    const {
      nfListUI,
      exportExcelUI,
      addNFEmailTrackingUI,
      removeNFEmailTrackingUI,
      exportDetailedExcelUI,
      searchFieldIsInUse,
      nfList,
    } = this.props;
    const {
      nfDetailsIsVisible,
      openOccurenceTab,
      openReceiptTab,
      showTrackingManager,
      showTable,
      showNewForm,
    } = this.state;
    document.body.style.overflow = nfDetailsIsVisible ? 'hidden' : 'visible';

    const isLoading =
      nfListUI.isFetching ||
      addNFEmailTrackingUI.isFetching ||
      removeNFEmailTrackingUI.isFetching;

    return (
      <div className="luft-tracking">
        <div className="Tracking__header-container">
          <SubHeader
            title="Tracking Integrado"
            renderSide={() => (
              <div className="Tracking__header-search-container">
                <SearchSecondary
                  placeholder="Buscar por NF ou Pedido"
                  onSearch={this._onSearch}
                  onClose={this._onClose}
                  searchFieldIsInUse={searchFieldIsInUse}
                  list={nfList}
                  minSubmitChars={1}
                  isLoading={isLoading}
                />
                <SheetDownload
                  exportXLS={this._exportXLS}
                  exportDetailedXLS={this._exportDetailedXLS}
                  exportXLSFetching={exportExcelUI.isFetching}
                  exportDetailXLSFetching={exportDetailedExcelUI.isFetching}
                />
              </div>
            )}
          />
          <NFFilters />
        </div>
        <div className="luft-tracking-content">
          {isLoading ? (
            <div className="load-skeleton-container">
              {[1, 2, 3].map(item => (
                <SkeletonTrackingCard key={item} />
              ))}
            </div>
          ) : (
            <TrackingNFList
              onNFClick={this._onNFClick}
              onNFConfirmationClick={this._onNFConfirmationClick}
              openOccurence={this._openOccurence}
              openReceipt={this._openReceipt}
            />
          )}
        </div>
        {nfDetailsIsVisible && (
          <Details
            onTrackingManager={this._onTrackingManager}
            showTrackingManager={showTrackingManager}
            showTable={showTable}
            showNewForm={showNewForm}
            setShowTable={this._setShowTable}
            setShowNewForm={this._setShowNewForm}
            onDismiss={this._toggleSidePanel}
            openOccurenceTab={openOccurenceTab}
            openReceiptTab={openReceiptTab}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    nfListUI: getNFListUI(state),
    exportDetailedExcelUI: getTrackingExportDetailedExcelUI(state),
    exportExcelUI: getTrackingExportExcelUI(state),
    addNFEmailTrackingUI: getAddNFEmailTrackingUI(state),
    removeNFEmailTrackingUI: getRemoveNFEmailTrackingUI(state),
    listPerformance: state.tracking.filters.listPerformance,
    nfList: state.tracking.nfList.data.list,
    nfData: getCurrentNFDetails(state),
    searchFieldIsInUse: state.tracking.searchFieldIsInUse,
  };
}

export default connect(mapStateToProps)(Tracking);
